import { c as _c } from "react/compiler-runtime";
import type { Entity, VaultKind } from '@onefootprint/request-types/dashboard';
import { Pagination, useToast } from '@onefootprint/ui';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenPage } from '@/hooks/use-open-page';
import useEntitiesQueryParams from '../../hooks/use-entities-query-params';
import useEntities from './hooks/use-entities';
import Provider from './hooks/use-entities-context';
export type ListProps = {
  children: React.ReactNode;
  kind: VaultKind;
  basePath: string;
  defaultFilters?: Record<string, unknown>;
};
const List = t0 => {
  const $ = _c(24);
  const {
    children,
    kind,
    basePath,
    defaultFilters
  } = t0;
  const queryParams = useEntitiesQueryParams();
  const {
    data: response,
    isPending,
    errorMessage,
    pagination
  } = useEntities(kind, defaultFilters);
  const handleOpenPage = useOpenPage();
  const {
    t
  } = useTranslation("users");
  const {
    toast
  } = useToast();
  let t1;
  if ($[0] !== basePath || $[1] !== handleOpenPage || $[2] !== t || $[3] !== toast) {
    t1 = (entity, event) => {
      if (event.altKey) {
        navigator.clipboard.writeText(entity.id);
        toast({
          title: t(_temp),
          description: t(_temp2)
        });
        return;
      }
      handleOpenPage(event, `/${basePath}/${entity.id}`);
    };
    $[0] = basePath;
    $[1] = handleOpenPage;
    $[2] = t;
    $[3] = toast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleRowClick = t1;
  let t2;
  if ($[5] !== queryParams) {
    t2 = search => {
      queryParams.push({
        search,
        cursor: undefined
      });
    };
    $[5] = queryParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSearchChange = t2;
  const t3 = response?.data;
  let t4;
  if ($[7] !== pagination.hasNextPage || $[8] !== pagination.hasPrevPage || $[9] !== pagination.loadNextPage || $[10] !== pagination.loadPrevPage || $[11] !== pagination.pageIndex || $[12] !== pagination.pageSize) {
    t4 = (pagination.hasNextPage || pagination.hasPrevPage) && <Pagination hasNextPage={pagination.hasNextPage} hasPrevPage={pagination.hasPrevPage} onNextPage={pagination.loadNextPage} onPrevPage={pagination.loadPrevPage} pageIndex={pagination.pageIndex} pageSize={pagination.pageSize} />;
    $[7] = pagination.hasNextPage;
    $[8] = pagination.hasPrevPage;
    $[9] = pagination.loadNextPage;
    $[10] = pagination.loadPrevPage;
    $[11] = pagination.pageIndex;
    $[12] = pagination.pageSize;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children || $[15] !== errorMessage || $[16] !== handleRowClick || $[17] !== handleSearchChange || $[18] !== isPending || $[19] !== kind || $[20] !== queryParams.values.search || $[21] !== t3 || $[22] !== t4) {
    t5 = <Provider kind={kind} data={t3} errorMessage={errorMessage} initialSearch={queryParams.values.search} isPending={isPending} onRowClick={handleRowClick} onSearchChange={handleSearchChange}>{children}{t4}</Provider>;
    $[14] = children;
    $[15] = errorMessage;
    $[16] = handleRowClick;
    $[17] = handleSearchChange;
    $[18] = isPending;
    $[19] = kind;
    $[20] = queryParams.values.search;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
};
export default List;
function _temp($) {
  return $.table.copyFpIdToast.success;
}
function _temp2($_0) {
  return $_0.table.copyFpIdToast.description;
}